import React, {useState, useEffect, useRef, useMemo, useCallback} from "react";
import { useSelector } from 'react-redux';
import './styleContactos.scss';
import { SubNavBarComponent } from "../../components/layouts/layout1/subnavbar/SubNavBarComponent";
import { Button, TextField, Icon, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem } from '@material-ui/core';
import { getContacts, getProductsInterest, getListOfProductsInterest } from "../../actions/userActions";
import Dialog from '@material-ui/core/Dialog';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { type } from "jquery";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export const Contactos = () => {
    const requestH = useSelector((state) => state.user.request);
    const gridRef = useRef();

    const [rfcFilterValue, setRfcFilterValue] = useState('')
    const [emailFilterValue, setEmailFilterValue] = useState('')
    const [contactNameValue, setContactNameValue] = useState('')
    const [productsFilterValue, setProductsFilterValue] = useState('');
    const [contacts, setContacts] = useState([]);
    const [productsInt, setProductsInt] = useState([]);

    useEffect(() => {
        getListProducts();
        getContactos();
    }, [])

    const getContactos = async () => {
        onBtShowLoading()
        await getProductsInterest(requestH, 0).then(resp => {
            if (resp.response && resp.response.length > 0) {
                setContacts(resp.response)
                onBtHide()
            }
            else {
                onBtShowNoRows();
            }
        })
    }

    const getListProducts = async () => {
        await getListOfProductsInterest(requestH).then(resp => {
            if (resp.response && resp.response.length > 0) {
                setProductsInt(resp.response)
            }
            else
            {
                console.log("ERROR: ", resp.errorMessage)
            }
        })
    }

    /* Table */
    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [5, 10, 15, 20, 25, 50, 100, 500, 1000];
    const rowHeight = 70;
    const showScroll = true;

    const tableColumns = [
        {
            field: 'id', headerName: 'ID', suppressMovable: true, sortable: true, 
            minWidth: 100, maxWidth: 150, flex: 1 
        },
        {
            field: 'name', headerName: 'Nombre', type: 'contactName', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true
        },
        /*{
            field: 'firstLastName', headerName: 'Apellido Paterno', type: 'apPat', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        {
            field: 'secondLastName', headerName: 'Apellido Materno', type: 'apMat', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },*/
        {
            field: 'phone', headerName: 'Teléfono', type: 'text', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        {
            field: 'email', headerName: 'Email', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        {
            field: 'rfc', headerName: 'RFC', type: 'rfc', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        {
            field: 'comentario', headerName: 'Comentario', type: 'comment', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        {
            field: 'state', headerName: 'Estado', type: 'state', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        {
            field: 'city', headerName: 'Ciudad', type: 'city', suppressMovable: true, sortable: false, 
            wrapText: true, autoHeight: true 
        },
        { 
            field: 'productos', headerName: 'Productos de interés', type: 'productos', sortable: false, suppressMovable: true,
            wrapText: true, autoHeight: true
        },
    ]

    const defaultColDef = useMemo(() => {
        return {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            headerStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center"
            }),
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            })
        };
    }, []);

    const columnTypes = useMemo(() => {
        return { 
            contactName: {
                valueFormatter: getClientName
            },
            /*apPat: {
                valueFormatter: getLastName
            },
            apMat: {
                valueFormatter: getSecondLastName
            },*/
            phone: {
                valueFormatter: phoneFormat
            },
            rfc: {
                valueFormatter: getRFC
            },
            comment: {
                valueFormatter: getComment
            },
            state: {
                valueFormatter: getState
            },
            city: {
                valueFormatter: getCity
            },
            productos: {
                valueFormatter: getProductos
            }
        };
    }, []);

    const autoSizeStrategy = {
        type: 'fitGridWidth',
        //type: 'fitCellContents',
        defaultMinWidth: 100,
    };

    function getClientName(data) {
        if (data.data.name) {
            if (data.data.name == 'null') {
                return '-'
            }
            return data.data.name
        } else {
            return '-'
        }
    }

    function getLastName(data) {
        if (data.data.firstLastName) {
            if (data.data.firstLastName == 'null') {
                return '-'
            }
            return data.data.firstLastName
        } else {
            return '-'
        }
    }

    function getSecondLastName(data) {
        if (data.data.secondLastName) {
            if (data.data.secondLastName == 'null') {
                return '-'
            }
            return data.data.secondLastName
        } else {
            return '-'
        }
    }

    function phoneFormat(data) {
        if (data.data.phone) {
            if (data.data.phone == 'null') {
                return '-'
            }
            return `(${data.data.phone.slice(0,3)}) ${data.data.phone.slice(3,6)}-${data.data.phone.slice(6,10)}`;
        } else {
            return '-'
        }
    }

    function getRFC(data) {
        if (data.data.rfc) {
            if (data.data.rfc == 'null') {
                return '-'
            }
            return data.data.rfc
        } else {
            return '-'
        }
    }

    function getComment(data) {
        if (data.data.comentario) {
            if (data.data.comentario == 'null') {
                return '-'
            }
            return data.data.comentario
        } else {
            return '-'
        }
    }

    function getState(data) {
        if (data.data.state) {
            if (data.data.state == 'null') {
                return '-'
            }
            return data.data.state
        } else {
            return '-'
        }
    }

    function getCity(data) {
        if (data.data.city) {
            if (data.data.city == 'null') {
                return '-'
            }
            return data.data.city
        } else {
            return '-'
        }
    }

    function getProductos(data) {
        if (data.data.productos) {
            if (data.data.productos == 'null') {
                return '-'
            }
            return data.data.productos
        } else {
            return '-'
        }
    }

    function getEye(data) {
        return (
            //data.data.id
            <Icon style={{ color: 'black', cursor: 'pointer' }} onClick={() => getProductsInt(data.data.id)}>visibility_icon</Icon>
        )
    }

    //FILTROS DE BÚSQUEDA
    var rfcFilter = "";
    var emailFilter = "";
    var contactNameFilter = "";
    var productsFilter = "";

    const cleanFilters = () => {
        setRfcFilterValue('');
        setEmailFilterValue('');
        setContactNameValue('');
        setProductsFilterValue('');

        rfcFilter = "";
        emailFilter = "";
        contactNameFilter = "";
        productsFilter = "";

        externalFilterChanged("", "", "", "");
        
    }

    const externalFilterChanged = useCallback((rfc, email, client, product) => {
        rfcFilter = rfc.toUpperCase();
        emailFilter = email;
        contactNameFilter = client.toUpperCase();
        productsFilter = product;
        gridRef.current.api.onFilterChanged();
    }, []);

    const isExternalFilterPresent = useCallback(() => {
        if (rfcFilter) {
            return rfcFilter !== ""
        } else if (emailFilter) {
            return emailFilter !== ""
        } else if (contactNameFilter) {
            return contactNameFilter !== ""
        } else if (productsFilter) {
            return productsFilter !== ""
        } 
        else {
            return false
        }
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (node.data) {
                return (
                    (productsFilter == "" || node.data.productos.includes(productsFilter)) &&
                    node.data.rfc.includes(rfcFilter) &&
                    node.data.email.includes(emailFilter) &&
                    node.data.name.toUpperCase().includes(contactNameFilter)
                )
            }
            return true;
        },
        []
    );

    const searchValues = () => {
        externalFilterChanged(rfcFilterValue, emailFilterValue, contactNameValue, productsFilterValue)
    }

    const [loading, setLoading] = useState(false); 
    //función para implementar loading a la tabla
    const onBtShowLoading = () => {
        //gridRef.current.api.showLoadingOverlay();
        setLoading(true);
    }

    const onBtShowNoRows = () => {
        //gridRef.current.api.showNoRowsOverlay();
        setLoading(false)
    }

    const onBtHide = () => {
        //gridRef.current.api.hideOverlay();
        setLoading(false)
    }

    return (
        <div className='container'>
            <SubNavBarComponent title={'CONTACTOS'} />

            {/* -------------------------- TABLE ----------------------------- */}
            <div className='tableContainer'>
                <div style={{ width: '100%', display: 'flex', fontSize: '18px', fontFamily: 'Montserrat, sans-serif', color: '#094070',
                            fontWeight: '700' }}>
                    FILTROS DE BÚSQUEDA
                </div>
                <div className='filterContainer'>
                    <TextField
                        margin='dense'
                        label='RFC'
                        variant='outlined'
                        type='text'
                        value={rfcFilterValue}
                        onChange={(event) => { setRfcFilterValue(event.target.value) }}
                        style={{ marginRight: '10px', width: 'auto' }}
                        inputProps={{ style: { textTransform: "uppercase" }, pattern: '^[\wÀ-ÿ\u00f1\u00d1]+(\s[\wÀ-ÿ\u00f1\u00d1]+)*$', maxLength: 16 }}
                    />

                    <TextField
                        margin='dense'
                        label='Email'
                        variant='outlined'
                        type='text'
                        value={emailFilterValue}
                        onChange={(event) => { setEmailFilterValue(event.target.value) }}
                        style={{ marginRight: '10px', width: 'auto' }}
                        inputProps={{ pattern: '^[\wÀ-ÿ\u00f1\u00d1]+(\s[\wÀ-ÿ\u00f1\u00d1]+)*$' }}
                    />

                    <TextField
                        margin='dense'
                        label='Nombre'
                        variant='outlined'
                        type='text'
                        value={contactNameValue}
                        onChange={(event) => { setContactNameValue(event.target.value) }}
                        style={{ marginRight: '10px', width: 'auto' }}
                        inputProps={{ pattern: '^[\wÀ-ÿ\u00f1\u00d1]+(\s[\wÀ-ÿ\u00f1\u00d1]+)*$' }}
                    />

                    <TextField
                        margin="dense"
                        label="Categorías de interés"
                        variant="outlined"
                        select
                        style={{ marginRight: '10px', width: '26ch' }}
                        onChange={(event) => { setProductsFilterValue(event.target.value) }}
                        value={productsFilterValue}
                    >
                        {productsInt.map((option) => (
                            <MenuItem key={option.id} value={option.name}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>

                    <button className='filterButtons' onClick={searchValues}>
                        BUSCAR
                    </button>

                    <button className='filterButtons' onClick={() => cleanFilters()}>
                        LIMPIAR FILTROS
                    </button>
                </div>

                {loading ? 
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh'}}>
                    <CircularProgress />
                </div> :

                <div
                    className="ag-theme-quartz" // applying the grid theme
                    style={{ height: 700 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact 
                        ref={gridRef}
                        rowData={contacts}
                        columnDefs={tableColumns}
                        columnTypes={columnTypes}
                        defaultColDef={defaultColDef}
                        pagination={pagination}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                        rowHeight={rowHeight}
                        autoSizeStrategy={autoSizeStrategy}
                        alwaysShowHorizontalScroll={showScroll}
                        isExternalFilterPresent={isExternalFilterPresent}
                        doesExternalFilterPass={doesExternalFilterPass}
                    />
                </div>
                }
            </div>

        </div>
    )
}